export const getValue = (key: string, obj: any) => obj[key];
